var React = require('react');

function JsInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 0v80h80V0H0zm43.536 62.393c0 7.786-4.572 11.34-11.232 11.34-6.018 0-9.5-3.108-11.286-6.876l6.125-3.696c1.178 2.089 2.25 3.857 4.84 3.857 2.463 0 4.035-.964 4.035-4.732V36.732h7.518v25.66zm17.785 11.34c-6.982 0-11.5-3.322-13.696-7.68l6.125-3.535c1.607 2.625 3.714 4.571 7.41 4.571 3.108 0 5.108-1.553 5.108-3.714 0-2.571-2.036-3.482-5.482-5l-1.875-.804c-5.429-2.303-9.018-5.214-9.018-11.339 0-5.643 4.303-9.928 11-9.928 4.786 0 8.214 1.66 10.678 6.017l-5.857 3.75c-1.285-2.303-2.678-3.214-4.839-3.214-2.196 0-3.59 1.393-3.59 3.214 0 2.25 1.394 3.161 4.626 4.572l1.875.803c6.393 2.733 9.982 5.536 9.982 11.822 0 6.75-5.322 10.464-12.447 10.464z"}));
}

JsInline.defaultProps = {"viewBox":"0 0 80 80"};

module.exports = JsInline;

JsInline.default = JsInline;
